import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import fetchJustForYou from '@/redux/thunk/just-for-you-thunk';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';
import JustForYouSlider from '../Slider/JustForYouSlider';

function JustForYouCarousel({ section }) {
  const pathname = usePathname();
  const dispatch = useDispatch();

  const { items, isLoading } = useSelector((state) => state.justForYou);
  const { lang: selectLang } = useSelector((state) => state.globalSettings);

  const isPDP = () => pathname.startsWith('/product/');

  useEffect(() => {
    dispatch(fetchJustForYou());
  }, []);

  if (Array.isArray(items) && items?.length === 0) {
    return null;
  }

  if (!Array.isArray(items) || items?.length === 0) {
    return null;
  }

  return (
    <section
      className="just-for-you"
      role="presentation"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={cn('container mx-auto', {
          '3xl:max-w-[1440px]': !isPDP,
        })}
      >
        <DynamicSectionTitle
          text={`${section?.title[selectLang]}`}
          className={cn({
            'text-center': pathname === '/',
          })}
        />
      </div>
      <JustForYouSlider items={items} isLoading={isLoading} />
    </section>
  );
}

export default JustForYouCarousel;
